<template>
  <v-container class="h-100 pa-4" fluid>
    <v-row justify="center" class="h-100">
      <OrderDetailComponent :order="order"></OrderDetailComponent> </v-row
  ></v-container>
</template>

<script lang="ts" setup>
import OrderDetailComponent from '@/components/orders/OrderDetailComponent.vue';
import { OrderDTO } from '@/dtos';
import { useOrderStore } from '@/stores/';
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const orderStore = useOrderStore();
const orderId = ref(
  Array.isArray(route.params.orderId) ? route.params.orderId[0] : (route.params.orderId ?? ''),
);

const query = orderStore.getOrderByIdQuery(orderId);

const order = computed(() => {
  return query.data.value ?? new OrderDTO();
});
</script>
